module.exports = __webpack_public_path__ + "media/images/projects/15-header-445ce916ce63dad3fec09d91572f015d.jpg";